import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Dialog, DialogContent } from '@mui/material'
import { BasicDialogAction, BasicDialogTitle } from 'common/components/modal/DialogComponents'
import TicketsPicker from './TicketsPicker'

// Ajoute des tickets à un lot. onAdd(ids) doit renvoyer une promesse : le bouton reste en chargement jusqu'à sa résolution.
const DialogAddTicket = ({
    open,
    lot,
    tickets = [],
    onClose = () => {},
    onAdd = () => Promise.resolve(),
}) => {
    const [ids, setIds] = useState([])
    const [isSaving, setIsSaving] = useState(false)

    const close = () => {
        setIds([])
        onClose()
    }

    const add = () => {
        setIsSaving(true)
        onAdd(ids).then(close).finally(() => setIsSaving(false))
    }

    return (
        <Dialog
            open={open}
            onClose={close}
            maxWidth='sm'
            fullWidth
        >
            <BasicDialogTitle onClose={close}>{`Ajouter des tickets au lot ${lot}`}</BasicDialogTitle>
            <DialogContent>
                <TicketsPicker tickets={tickets} targetLot={lot} values={ids} onChange={setIds} />
            </DialogContent>
            <BasicDialogAction
                buttonLabel='Ajouter'
                onValidate={add}
                isLoading={isSaving}
                isDisabled={ids.length === 0}
            />
        </Dialog>
    )
}

DialogAddTicket.propTypes = {
    lot: PropTypes.string,
    tickets: PropTypes.arrayOf(PropTypes.shape({})),
    open: PropTypes.bool,
    onClose: PropTypes.func,
    onAdd: PropTypes.func,
}

export default DialogAddTicket
